import { render, staticRenderFns } from "./NominaIncidencias.vue?vue&type=template&id=39244c2a&"
import script from "./NominaIncidencias.vue?vue&type=script&lang=js&"
export * from "./NominaIncidencias.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports